import React, { useContext } from 'react';
import {
  UploadOutlined,
  FileOutlined,
  CopyOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { Upload, Modal } from 'antd';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import { AppContext } from 'App.context.js';
import useHbxUploadExampleInvoices from './HbxUploadExampleInvoices.hook';
import RequestSuscription from '../../../common/RequestSuscription/RequestSuscription.jsx';
import styles from './HbxUploadExampleInvoices.styles';
import Loading from '../../../common/Loader/Loading';
import InfoView from 'Components/common/InfoView/InfoView';
import AdviceDeleteFile from '../AdviceDeleteFile/AdviceDeleteFile.jsx';

export default function HbxUploadExampleInvoices() {
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  const { state, actions } = useHbxUploadExampleInvoices();

  return (
    <DefaultLayout singleBox>
      {state.suscription ? (
        <div>
          {state.isLoading || !appState?.hotelList?.length ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {state.isLoading ? (
                <Loading />
              ) : (
                <InfoView text={translate('emptyHotelListError')} icon={<InfoCircleOutlined />} />
              )}
            </div>
          ) : (
            <div style={styles.container}>
              <div style={styles.buttonWrapper}>
                <div style={styles.buttonTitle}>
                  <FileOutlined style={styles.buttonTitleIcon} />
                  {translate('hbxProducts.HbxUploadExampleInvoices.upload')}
                  {state.existsSingle ? (
                    <CheckCircleOutlined style={{ color: 'green', marginLeft: 8 }} />
                  ) : (
                    <CloseCircleOutlined style={{ color: 'red', marginLeft: 8 }} />
                  )}
                </div>

                {state.existsSingle ? (
                  <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                    <div
                      style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                      onClick={() => actions.downloadFile('single')}
                    >
                      <span style={{ marginRight: 8 }}>
                        {translate('hbxProducts.HbxUploadExampleInvoices.downloadFile')}
                      </span>
                      <DownloadOutlined style={{ fontSize: 22 }} />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: 'red',
                      }}
                      onClick={() => {
                        actions.setType('single');
                        actions.setAdviceDeleteFile(true);
                      }}
                    >
                      <span style={{ marginRight: 8 }}>
                        {translate('hbxProducts.HbxUploadExampleInvoices.deleteFile')}
                      </span>
                      <DeleteOutlined style={{ fontSize: 22 }} />
                    </div>
                  </div>
                ) : (
                  <Upload
                    accept=".pdf"
                    maxCount={1}
                    beforeUpload={file => {
                      actions.uploadSingleFile(file);
                      return false;
                    }}
                    showUploadList={false}
                  >
                    <div style={styles.buttonBox}>
                      <UploadOutlined style={styles.buttonIcon} />
                      <span style={styles.buttonText}>
                        {translate('hbxProducts.HbxUploadExampleInvoices.uploadFile')}
                      </span>
                    </div>
                  </Upload>
                )}
              </div>

              <div style={styles.buttonWrapper}>
                <div style={styles.buttonTitle}>
                  <CopyOutlined style={styles.buttonTitleIcon} />
                  {translate('hbxProducts.HbxUploadExampleInvoices.uploadMultiple')}
                  {state.existsMultiple ? (
                    <CheckCircleOutlined style={{ color: 'green', marginLeft: 8 }} />
                  ) : (
                    <CloseCircleOutlined style={{ color: 'red', marginLeft: 8 }} />
                  )}
                </div>

                {state.existsMultiple ? (
                  <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                    <div
                      style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                      onClick={() => actions.downloadFile('multiple')}
                    >
                      <span style={{ marginRight: 8 }}>
                        {translate('hbxProducts.HbxUploadExampleInvoices.downloadFile')}
                      </span>
                      <DownloadOutlined style={{ fontSize: 22 }} />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: 'red',
                      }}
                      onClick={() => {
                        actions.setType('multiple');
                        actions.setAdviceDeleteFile(true);
                      }}
                    >
                      <span style={{ marginRight: 8 }}>
                        {translate('hbxProducts.HbxUploadExampleInvoices.deleteFile')}
                      </span>
                      <DeleteOutlined style={{ fontSize: 22 }} />
                    </div>
                  </div>
                ) : (
                  <Upload
                    accept=".pdf"
                    multiple
                    beforeUpload={file => {
                      actions.uploadMultipleFiles(file);
                      return false;
                    }}
                    showUploadList={false}
                  >
                    <div style={styles.buttonBox}>
                      <UploadOutlined style={styles.buttonIcon} />
                      <span style={styles.buttonText}>
                        {translate('hbxProducts.HbxUploadExampleInvoices.uploadMultipleFile')}
                      </span>
                    </div>
                  </Upload>
                )}
              </div>

              <Modal
                title={translate('hbxProducts.adviceDeleteFile')}
                open={state.adviceDeleteFile}
                onCancel={() => actions.setAdviceDeleteFile(false)}
                cancelText={translate('hbxProducts.cancel')}
                onOk={() => {
                  actions.setAdviceDeleteFile(false);
                  actions.deleteFile();
                }}
                okText={translate('hbxProducts.delete')}
                okType={'danger'}
              >
                <AdviceDeleteFile setShowModal={actions.setAdviceDeleteFile} />
              </Modal>
            </div>
          )}
        </div>
      ) : (
        <RequestSuscription suscription="hbx_invoicing" />
      )}
    </DefaultLayout>
  );
}
